/**
 * Environment "dev" — CRM local pegando al backend DEV en el VPS.
 *
 * Se activa con:
 *   npm run start:dev
 *
 * El backend api-dev.invertus.miclickderecho.com corre en el mismo VPS
 * que prod pero contra la BD invertus_dev (clon refrescable de prod).
 * Este es el modo recomendado para trabajar contra pipeline IA end-to-end
 * (n8n dev también existe y hace callback al backend dev).
 *
 * NO cambia el default: `npm start` sigue apuntando a prod
 * (`environment.ts`), útil para desarrolladores que solo hacen cambios
 * de frontend contra data real.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api-dev.invertus.miclickderecho.com',
  appName: 'Invertus CRM (dev)',
  // Franja de advertencia permanente. Ver el comentario de arriba: DEV
  // comparte la llave de secretos con produccion, asi que sus
  // integraciones son las reales.
  avisoAmbiente:
    'Este CRM apunta a un ambiente de DESARROLLO, pero sus integraciones (redes sociales, SIMI, correo y WhatsApp) usan las credenciales REALES de producción. Lo que publiques o envíes desde acá sale de verdad.'
};
